import { Avatar, Box, MenuItem, Select, Typography } from "@mui/material";
import { Fragment, ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import appServices from "../../../services/app-services/appServices";
import { convertUserImage } from "../../../util/utils";
import { T } from "react-translator-component";
import ReimbursementTable from "../../../components/ReimbursementTable";
import ButtonOutlinedCentered from "../../../components/ButtonOutlined";
import GCBackButton from "../../../components/GreenCity/GCBackButton";
import style from "./styles";

function ShowReimbursements(): ReactElement {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const years = Array.from({ length: 50 }, (_, i) => 2024 + i);
  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  const navigate = useNavigate();
  const { user } = useSelector((state: any) => state.userAuth);
  const [reimbursements, setReimbursements] = useState<any[]>([]);
  const [selectedYear, setSelectedYear] = useState(currentYear.toString());
  const [selectedMonth, setSelectedMonth] = useState(currentMonth.toString());

  // Fetch reimbursements
  useEffect(() => {
    if (user?.id) getPaymentReimbursements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]); // Added dependency to watch user.id changes

  const getPaymentReimbursements = async () => {
    try {
      const res = await appServices.getPaymentReimbursements(user.id, selectedYear, selectedMonth);
      setReimbursements(res.reimbursements || []); // Ensure fallback to an empty array
    } catch (error) {
      console.error("Error fetching reimbursements:", error);
    }
  };

  return (
    <div style={{ paddingTop: 100, margin: 4 }}>
      <GCBackButton onClick={() => navigate(-1)} />
      <div style={{ margin: 14 }}>
        <Box sx={style.rowMargin}>
          <Avatar src={convertUserImage(user?.image)} sx={{ ...style.avatar, width: "30px" }} />
          <Typography>{T("reimbursement_history")}</Typography>
        </Box>
        <Typography sx={style.titleSeprator}>{T("reimbursement_created_at_month")}</Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <Select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} displayEmpty sx={{ width: "33%", backgroundColor: "white", height: "40px" }}>
            <MenuItem value="" disabled>
              {selectedYear} {T("year")}
            </MenuItem>
            {years.map((yr) => (
              <MenuItem key={yr} value={yr}>
                {yr}
              </MenuItem>
            ))}
          </Select>
          <Select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} displayEmpty sx={{ width: "30%", backgroundColor: "white", height: "40px" }}>
            <MenuItem value="" disabled>
              {selectedMonth} {T("month")}
            </MenuItem>
            {months.map((mn) => (
              <MenuItem key={mn} value={mn}>
                {mn}
              </MenuItem>
            ))}
          </Select>

          <ButtonOutlinedCentered onClick={() => getPaymentReimbursements()} title={T("display")}/>
        </Box>
        {reimbursements.map((reimbursement: any, index: number) => (
          <Fragment key={index}>
            <ReimbursementTable reimbursement={reimbursement} />
            <hr />
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export default ShowReimbursements;
